import { render, staticRenderFns } from "./scheduleComs.vue?vue&type=template&id=9ac5cbae&"
import script from "./scheduleComs.vue?vue&type=script&lang=js&"
export * from "./scheduleComs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports